import { request, seg } from "./http";
import type { MetricsSummary } from "./types";

export const metricsApi = {
  summary: (workspaceId: string, signal?: AbortSignal) =>
    request<MetricsSummary>("GET", `/v1/workspaces/${seg(workspaceId)}/metrics/summary`, undefined, { signal }),
};
